<template>
  <header id="header">
    <NuxtLink to="/" class="logo">
      <!-- <img v-if="false" class="logo" src="@/assets/img/kubma.png" alt="logo" /> -->
      <span class="company__name">Kubma</span>
    </NuxtLink>
    <div class="menu" @click.stop="menu = !menu">
      <i
        :class="{ fa: true, 'fa-bars': !menu, 'fa-times': menu }"
        aria-hidden="true"
      ></i>
    </div>
  </header>
</template>

<script setup>
const { $isIOS } = useNuxtApp();
const menu = ref(false);

// const baseUrl = computed(() => {
//   return process.env.VUE_APP_PRELOAD_ICONS + "/icons";
// });
</script>

<style lang="scss" scoped>
$bg-primary: black;
$c-primary: #ff6;

//prevent css
$bg: transparent;
$fs: 20px;
$ff: "Poppins", sans-serif;
$c: white;
.wrapper {
  font-family: inherit;
  background-color: $bg;
  margin-bottom: 1rem;
  @include respond-below(md) {
    background-color: unset;
    position: absolute;
    z-index: 100;
    width: 100%;
  }
}
header {
  margin-bottom: 0.3rem;
  background-color: $bg-primary;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.4rem 1rem;
  position: relative;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 99;
  //background-color: ;
  &.static {
  }
  @include respond-below(sm) {
    position: unset;
    padding: 0.4rem 1rem;
  }
  .logo {
    display: flex;
    align-items: center;
    text-decoration: none;
    width: 100px;
    height: 60px;
    /* object-fit: cover;
    box-shadow: 0 5px 10px rgba($color: #000, $alpha: 0.08); */
  }
  .company__name {
    @include primary-font(35px, 500, white);
    @include respond-below(sm) {
      @include primary-font(22px, 500, white);
    }
  }

  .menu {
    font-size: 1.2rem;
    color: white;
    @include respond-above(sm) {
      display: none;
    }
  }
  /*Search UI */
  .search-comp {
    @include respond-below(sm) {
      display: none;
    }
    display: flex;
    width: 500px;
    @include respond-below(md) {
      width: 50vw;
    }
    height: 30px;
    &.isMobile-acive {
      display: none;
    }
    .dropdown {
      min-width: 180px;
      max-width: 100%;
      border-radius: 0.3rem 0 0 0.3rem;
      // overflow: hidden;
    }
  }

  /*Link Group */
  .link-group {
    .only-sm {
      display: none;
    }
    @include respond-below(sm) {
      display: none;
      .only-sm {
        display: unset;
      }
    }

    &.option {
      display: revert;
      position: absolute;
      top: 0;
      left: 0;
      width: 250px;
      height: 100vh;
      @supports not (height: 100vh) {
        height: 100%;
      }
      inset: 0;
      z-index: 999999;
      // background: #16033ecc;
      background: rgb(61 59 64 / 80%);
      display: flex;
      flex-flow: wrap column;
      animation: slide-menu 0.2s ease forwards;
      a {
        padding-bottom: 0.3rem;
        // border-bottom: 1px solid white;
        margin: 1rem;
        font-size: 18px;
        &:hover {
          text-decoration: none;
          align-items: center;
          display: flex;
          padding: 0rem 0.7rem;
          width: 89%;
          height: 44px;
          border: none;
          background-color: black;
          color: white;
          border-radius: 10px;
        }
      }
      @keyframes slide-menu {
        from {
          left: -100%;
        }
      }
    }

    a {
      @include primary-font(16px, 500, white);
      text-decoration: unset;
      &:hover {
        text-decoration: underline;
      }
      &:not(:last-child) {
        margin-right: 1rem;
      }
      &:last-child {
        margin-right: 1rem;
      }
      @include respond-above(sm) {
        // background-color: #052741;
        padding: 0 0.3rem;
        border-radius: 4px;
      }
    }

    // @include respond-above(md) {
    //   a {
    //     &:nth-child(2) {
    //       margin-right: 0;
    //     }
    //   }
    // }
  }
}
</style>
